import React from 'react';
import pull = require("lodash/pull");
import {MdTextField} from 'core/components/fields/fields';
import {lovLabel, lovValue, FormProps, ClosedContentProps} from 'core/form/formUtils';
import {createForm} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {MdIconButton} from "core/components/buttons/icons";
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import Add from "material-ui/svg-icons/content/add";
import {addSeparator} from "core/common/utils/arrayUtils";
import {MdDivider} from "core/components/blockComp/blockComp";
import {CONFIGLEVEL} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {ObservableMap, action} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {MdFieldDto, FieldDefaultTable} from "core/metamodel/metaDomain";
import {optionsSearch} from "core/common/service/commonDataService";


interface FieldDefaultListProps {
  fieldObject: MdFieldDto;
  rootObject: MdFieldDto;
  entities: ObservableMap<MdEntity>;
  entity: MdEntity;
}

@observer
export default class FieldDefaultList extends React.Component<FieldDefaultListProps, undefined> {


  @action addDefault = () => {
    console.debug('addDefault');
    const {fieldObject, rootObject} = this.props;
    let newDefault = new FieldDefaultTable({
      $new: true,
      $added: true,
      entityName: fieldObject.entityName,
      fieldName: fieldObject.fieldName,
      configLevel: CONFIGLEVEL.GLOBAL
    });
    fieldObject.defaults.push(newDefault);
    rootObject.$dirty = true;
  };



  render() {

    const {fieldObject, entities, entity, rootObject} = this.props;

    const header = (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <div>Field Defaults</div>
        <MdIconButton onClick={this.addDefault}>
          <Add />
        </MdIconButton>
      </div>
    );

    return (
      <BlockComp header={header}  noPadding={true} style={{display: 'flex', flexDirection: 'column'}} >
        {
          addSeparator( fieldObject.defaults.map((fd, index) => <FieldDefaultTableForm dataObject={fd} rootObject={rootObject} key={index}
                                                                                              entities={entities} entity={entity}
                                                                                              index={index} /> ), <MdDivider inset/>)
        }
      </BlockComp>
    );
  }
}

const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<FieldDefaultTable>) => (
  <div style={{display: 'flex', fontSize: 16, lineHeight: '14px'}}>
    <div className="zz-grey-text zz-mr-5">{lovLabel(dataObject.configLevel)}</div>
    { (lovValue(dataObject.configLevel) === CONFIGLEVEL.TENANTGROUP) ? <div className="zz-grey-text">{lovLabel(dataObject.tenantGroup)}</div> : null}
    { (lovValue(dataObject.configLevel) === CONFIGLEVEL.TENANT) ? <div className="zz-grey-text">{lovLabel(dataObject.tenant)}</div> : null}
    { (lovValue(dataObject.configLevel) === CONFIGLEVEL.USER) ? <div className="zz-grey-text">{lovLabel(dataObject.user)}</div> : null}
    { (dataObject.language) ? <div className="zz-grey-text zz-ml-5">({lovLabel(dataObject.language)})</div> : null}
    <div className="zz-ml-10">{dataObject.value}</div>
  </div>
);

@createForm({
  formName: 'FieldDefaultTableForm',
  fields: [{
    name: 'value'
  }, {
    name: 'tenantGroup',
    validators: ['IsRequired']
  }, {
    name: 'tenant',
    validators: ['IsRequired']
  }, {
    name: 'user',
    validators: ['IsRequired']
  }, {
    name: 'configLevel',
    validators: ['IsRequired']
  }, {
    name: 'language'
  }]
}, ClosedContent)
@observer
class FieldDefaultTableForm extends React.Component<FormProps<FieldDefaultTable, MdFieldDto>, undefined> {

  @action onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);
    pull(this.props.rootObject.defaults, this.props.dataObject);
  };

  @action handleConfigLevelChange = () => {
    let {dataObject, rootObject, formName} = this.props;
    console.log('handleConfigLevelChange ', dataObject.configLevel);

    dataObject.tenant = null;
    dataObject.tenantGroup = null;
    dataObject.user = null;

    dataObject.getForm(formName).updateAllFieldsPropValue(dataObject);
  };


  render() {


    const {dataObject, rootObject, index, entities, formName, entity} = this.props;
    const fields = dataObject.getFormFields(formName);
    let {value, configLevel, tenantGroup, tenant, user, language} = fields;



    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...configLevel.props}  />
            <Validate field={configLevel} value={configLevel.props.value} onSuccess={this.handleConfigLevelChange}/>
          </div>

          { (lovValue(dataObject.configLevel) === CONFIGLEVEL.TENANTGROUP) ?
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...tenantGroup.props}/>
              <Validate field={tenantGroup} value={tenantGroup.props.value}/>
            </div>
            : null}

          { (lovValue(dataObject.configLevel) === CONFIGLEVEL.TENANT) ?
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...tenant.props}/>
              <Validate field={tenant} value={tenant.props.value}/>
            </div>
            : null}

          { (lovValue(dataObject.configLevel) === CONFIGLEVEL.USER) ?
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...user.props} async loadOptions={optionsSearch.bind(this, 'User', {})} clearable asterixForAll/>
              <Validate field={user} value={user.props.value}/>
            </div>
            : null}

          <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...language.props}/>
          </div>

        </div>
        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...value.props} />
          </div>
        </div>
      </div>
    );


    return (
      <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} key={index} onDelete={this.onDelete} validate={this.props.validate} {...this.props} />
    );
  }
}





// WEBPACK FOOTER //
// ./src/core/metamodel/component/fieldDefaultList.tsx